/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".referral-rewards-summary[_ngcontent-%COMP%]{padding:0 0 10px}.referral-rewards-summary[_ngcontent-%COMP%]   .col[_ngcontent-%COMP%]{padding-left:0}.link-style[_ngcontent-%COMP%]{color:#06c;text-decoration:underline;cursor:default}.error-message[_ngcontent-%COMP%]{color:#c62828;padding:10px 0}\n/*# sourceMappingURL=guest-referral-rewards.component.css.map*/"];
export { styles as styles };
